import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import SelectProductName from "./SelectProductName";
import SelectBatchModal from "./SelectBatchModal";
import { useInsertOrUpdateBatchMutation } from "../../State/Api/PharmacyStockApiSlice";

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "6px", // Reduced vertical gap
  padding: "6px 0",
};


const rowStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr", // Two equal-width columns
  gap: "16px 24px", // vertical & horizontal gap
  alignItems: "start", // align labels & inputs to top
  marginBottom: "16px",
};


const groupStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  width: "100%", // Use full column width from grid
};

const inputStyle = {
  padding: "6px 8px", // slightly tighter padding
  borderRadius: "5px",
  border: "1px solid #dedede",
  fontSize: "13px",
  width: "100%",
  boxSizing: "border-box",
  transition: "all 0.2s ease-in-out",
  cursor:"pointer"
};

const actionStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};



function AddBatchForm({ onHide,  showStockOffcanvas , editData, isEditMode }) {

const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
const [selectedProduct, setSelectedProduct] = useState("");
const [batchList, setBatchList] = useState([]);

  const [gstRate, setGstRate] = useState("5");
  const [frontImages, setFrontImages] = useState([]);
  const [backImages, setBackImages] = useState([]);
  const [uploadTarget, setUploadTarget] = useState("front");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const frontInputRef = React.useRef(null);
  const backInputRef = React.useRef(null);
  
  const [insertOrUpdateBatch] = useInsertOrUpdateBatchMutation();
 
  
  const getInputStyle = (field, isError) => ({
    ...inputStyle,
    borderColor: isError ? "red" : "#dedede",
    fontSize: formik.values[field] ? "14px" : "13px",  // font size change
    color: formik.values[field] ? "#000000ff" : "#333",  // color change
    transition: "all 0.2s ease-in-out",
  });

  const handleRemoveImage = (type, index) => {
    if (type === "front") {
      const newImages = [...frontImages];
      newImages.splice(index, 1);
      setFrontImages(newImages);
    } else {
      const newImages = [...backImages];
      newImages.splice(index, 1);
      setBackImages(newImages);
    }
  };

  const formik = useFormik({
initialValues: {
      Id: 0,
      PharmaId: localStorage.getItem("userUniqueID") || "",
      productName: "",
      ProductId: 0,
      BatchNum: "",
      BatchExpireDate: "", // store as YYYY-MM or ISO string; normalized on submit
      MRPwithGST: "",
      GstType: "",
      HSNCode: "",
      HSNGst: 0,
      UnitsPerPack: "",
      PurchaseRate: "",
      IndividualSell: false,
      Quantity: 0,
      Barcode: "",
      Composition: "",
      ProductFrom: "", // maps to product name selection
      Locations: "",
      Category: "",
      FrontImageFile: "",
      BackImageFile: "",
      stockCombo: "",
      CreatedBy: localStorage.getItem("userUniqueID"),
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      BatchNum: Yup.string().required("*Required"),
      BatchExpireDate: Yup.string().required("*Required"),
      MRPwithGST: Yup.string().required("*Required"),
      HSNCode: Yup.string().required("*Required"),
      PurchaseRate: Yup.string().required("*Required"),
      UnitsPerPack: Yup.string().required("*Required"),
      Quantity: Yup.string().required("*Required"),
     
    }),
    onSubmit: async (values) => {
      try{
        const formData = new FormData();
        formData.append("Id", values.Id);
        formData.append("PharmaId", values.PharmaId);
        formData.append("ProductId", values.ProductId);
        formData.append("BatchNum", values.BatchNum);
        formData.append("BatchExpireDate", values.BatchExpireDate);
        formData.append("MRPwithGST", values.MRPwithGST);
        formData.append("GstType", values.GstType);
        formData.append("HSNCode", values.HSNCode);
        formData.append("HSNGst", values.HSNGst);
        formData.append("UnitsPerPack", values.UnitsPerPack);
        formData.append("PurchaseRate", values.PurchaseRate);
        formData.append("IndividualSell", values.IndividualSell);
        formData.append("Quantity", values.Quantity);
        formData.append("Barcode", values.Barcode);
        formData.append("Composition", values.Composition);
        formData.append("ProductFrom", values.ProductFrom);
        formData.append("Locations", values.Locations);
        formData.append("Category", values.Category);
        formData.append("FrontImageFile", values.FrontImageFile);
        formData.append("BackImageFile", values.BackImageFile);
        formData.append("CreatedBy", values.CreatedBy);
        const result = await insertOrUpdateBatch(formData).unwrap();
        formik.resetForm();
        onHide();
      }catch(err){
        console.log(err);
      }
    },
  });

  const handleProductName = (product) => {
    formik.setFieldValue("productName", product.productName);
    setSelectedProduct(product.productName);
    formik.setFieldValue("ProductId", product.productID);
    setIsModalOpen(false);
    setIsBatchModalOpen(true);
};

  
  return (
    <form style={formStyle} onSubmit={formik.handleSubmit}>
      {/* Header */}
      

   {/* Product Name + Batch Number Row */}
<div style={rowStyle}>
  <div style={groupStyle}>
    <label style={{ fontSize: "14px" }}>
      Product Name <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      name="productName"
      placeholder="Select Product Name"
      style={getInputStyle(
        "productName",
        formik.touched.productName && formik.errors.productName
      )}
      value={formik.values.productName}
      onClick={() => setIsModalOpen(true)}
      readOnly
    />
    {formik.touched.productName && formik.errors.productName && (
      <div style={{ color: "red", fontSize: "11px" }}>
        {formik.errors.productName}
      </div>
    )}
  </div>

  <div style={groupStyle}>
    <label style={{ fontSize: "14px" }}>
      Batch Number <span style={{ color: "red" }}>*</span>
    </label>
    <input
  type="text"
  name="BatchNum"
  placeholder="Select Batch"
  style={getInputStyle(
    "BatchNum",
    formik.touched.BatchNum && formik.errors.BatchNum
  )}
  value={formik.values.BatchNum}
  readOnly
 onClick={() => {
  if (selectedProduct) {
    setWarningMessage(""); 
    setIsBatchModalOpen(true);
  } else {
    setWarningMessage(" Please select a product name first");
  }
}}

/>
 {formik.touched.BatchNum && formik.errors.BatchNum && (
      <div style={{ color: "red", fontSize: "11px" }}>
        {formik.errors.BatchNum}
      </div>
      
    )}
    {warningMessage && (
  <div style={{ color: "#db1a1aff", fontSize: "12px", marginTop: "4px" }}>
    {warningMessage}
  </div>
)}

  </div>

  {/* Product name modal */}
  <SelectProductName
    isOpen={isModalOpen}
    onClose={() => setIsModalOpen(false)}
    onSelectProductName={handleProductName}
    setIsModalOpen={setIsModalOpen}
    formik={formik}
    setSelectedProduct={setSelectedProduct}
  />
  <SelectBatchModal
  isOpen={isBatchModalOpen}
  onClose={() => setIsBatchModalOpen(false)}
  productName={selectedProduct}
  onSelectBatch={(batch) => {
    console.log("Selected batch:", batch);
    formik.setFieldValue("BatchNum", batch);
    setIsBatchModalOpen(false);
  }}
  batchFormik={formik}
/>

</div>


      
      {/* Batch Info */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Units per Pack <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="unitsPerPack"
            style={getInputStyle("unitsPerPack", formik.touched.unitsPerPack && formik.errors.unitsPerPack)}
            value={formik.values.unitsPerPack}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.unitsPerPack && formik.errors.unitsPerPack && (
            <div style={{ color: "red", fontSize: "11px" }}>
              {formik.errors.unitsPerPack}
            </div>
          )}
          <span style={{ fontSize: "12px", color: "#464646ff" }}>
            <strong style={{ color: "#db1a1aff" }}>EXAMPLE:</strong> For a strip
            of capsules, the Units per Pack will be 10
          </span>
        </div>

        <div style={groupStyle}>
          <label>
            Batch Expiry Date <span style={{ color: "red" }}>*</span>
          </label>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="month"
              name="BatchExpireDate"
              placeholder="MMM"
              style={{ ...getInputStyle("BatchExpireDate", formik.touched.BatchExpireDate && formik.errors.BatchExpireDate) }}
              value={formik.values.BatchExpireDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />

          </div>
        </div>
        
      </div>

      {/* MRP and HSN */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            MRP (INCL GST) <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="MRPwithGST"
            style={getInputStyle("MRPwithGST", formik.touched.MRPwithGST && formik.errors.MRPwithGST)}
            value={formik.values.MRPwithGST}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.MRPwithGST && formik.errors.MRPwithGST && (
            <div style={{ color: "red", fontSize: "11px" }}>
              {formik.errors.MRPwithGST}
            </div>
          )}
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            HSN Code With GST Rate <span style={{ color: "red" }}>*</span>
          </label>
          <div style={{ display: "flex", gap: "8px" }}>
            <input
              type="text"
              name="HSNCode"
              style={{ ...getInputStyle("HSNCode", formik.touched.HSNCode && formik.errors.HSNCode), flex: "2" }}
              value={formik.values.HSNCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            
            <select
              name="HSNGst"
              style={{ ...getInputStyle("HSNGst", formik.touched.HSNGst && formik.errors.HSNGst), flex: "1" }}
              value={formik.values.HSNGst}
              onChange={formik.handleChange}
            >
              <option value="0">0 % gst</option>
              <option value="5">5 % gst</option>
              <option value="18">18 % gst</option>
              <option value="40">40 % gst</option>
            </select>
          </div>
        </div>
        
      </div>

      {/* Purchase Rate and Units */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Purchase Rate <span style={{ color: "red" }}>*</span>
          </label>
          <div style={{ display: "flex", gap: "6px" }}>
            <input
              type="text"
              name="PurchaseRate"
              style={{ ...getInputStyle("PurchaseRate", formik.touched.PurchaseRate && formik.errors.PurchaseRate), flex: 1 }}
              value={formik.values.PurchaseRate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
           
            <select
              name="GstType"
              style={{ ...getInputStyle("GstType", formik.touched.GstType && formik.errors.GstType), width: "100px" }}
              value={formik.values.GstType}
              onChange={formik.handleChange}
            >
              <option value="Excl gst">Excl gst</option>
              <option value="Incl gst">Incl gst</option>
            </select>
          </div>
        </div>
         {/* Sale Qty */}
      <div style={groupStyle}>
        <label style={{ fontSize: "14px" }}>Sale qty <span style={{ color: "#888" }}>(Optional)</span></label>
        <div
          style={{
            ...getInputStyle("batchNumber"),
            display: "flex",
            alignItems: "center",
            gap: "8px",
            backgroundColor: "#fff",
            cursor: "pointer",
          }}
          onClick={() =>
            formik.setFieldValue("IndividualSell", !formik.values.IndividualSell)
          }
        >
          <input
            type="checkbox"
            name="IndividualSell"
            checked={formik.values.IndividualSell}
            onChange={formik.handleChange}
            style={{
              ...getInputStyle("IndividualSell"),
              width: "16px",
              height: "16px",
              cursor: "pointer",
              accentColor: "#1921a4",
            }}
          />
          <span style={{ fontSize: "13px", color: "#333" }}>
            Enable Loose Billing
          </span>
        </div>
      </div>
      
      </div>

      {/* Quantity in Stock */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Quantity in Stock <span style={{ color: "red" }}>*</span>
          </label>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="text"
              name="Quantity"
              placeholder="Box"
              style={getInputStyle("Quantity", formik.touched.Quantity && formik.errors.Quantity)}
              value={formik.values.Quantity}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <input
              type="text"
              name="UnitsPerPack"
              placeholder="Units"
              style={getInputStyle("UnitsPerPack", formik.touched.UnitsPerPack && formik.errors.UnitsPerPack)}
              value={formik.values.UnitsPerPack}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {/* <input
              type="text"
              name="stockCombo"
              placeholder="Stock Combination"
              style={getInputStyle("stockCombo", formik.touched.stockCombo && formik.errors.stockCombo)}
              value={formik.values.stockCombo}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            /> */}
          </div>
          {formik.touched.UnitsPerPack && formik.errors.UnitsPerPack && (
            <div style={{ color: "red", fontSize: "11px" }}>
              {formik.errors.UnitsPerPack}
            </div>
          )}
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Barcode <span style={{ color: "#888" }}>(Optional)</span></label>
          <input
            type="text"
            name="Barcode"
            // placeholder="Press Space to Scan"
            style={getInputStyle("Barcode")}
            value={formik.values.Barcode}
            onChange={formik.handleChange}
          />
        </div>
      </div>

      {/* Optional Fields */}
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Composition <span style={{ color: "#888" }}>(Optional)</span></label>
          <input
            type="text"
            name="Composition"
            // placeholder="Type or Press Space Bar"
            style={getInputStyle("Composition")}
            value={formik.values.Composition}
            onChange={formik.handleChange}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Product Form <span style={{ color: "#888" }}>(Optional)</span></label>
          <input
            type="text"
            name="ProductFrom"
            // placeholder="Type or Press Space"
            style={getInputStyle("ProductFrom")}
            value={formik.values.ProductFrom}
            onChange={formik.handleChange}
          />
        </div>
      </div>

      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Location <span style={{ color: "#888" }}>(Optional)</span></label>
          <input
            type="text"
            name="Locations"
            placeholder="Enter Location Here"
            style={getInputStyle("Locations")}
            maxLength="10"
            value={formik.values.Locations}
            onChange={formik.handleChange}
          />
          <span style={{ fontSize: "11px", color: "#888" }}>
            {formik.values.Locations.length}/10
          </span>
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>Product Category <span style={{ color: "#888" }}>(Optional)</span></label>
          <input
            type="text"
            name="Category"
            // placeholder="Type or Press Space"
            style={getInputStyle("Category")}
            value={formik.values.Category}
            onChange={formik.handleChange}
          />
        </div>
      </div>

   

      {/* Product Image Section */}
      {!showStockOffcanvas && (
      <div style={{ marginTop: "20px" }}>
        <h5>Product Image</h5>

        <div
          style={{
            border: "2px dashed #61a561ff",
            borderRadius: "10px",
            padding: "20px",
            background: "#f9f9f9",
            textAlign: "center",
            position: "relative",
            marginTop: "4px",
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const files = Array.from(e.dataTransfer.files);
            if (uploadTarget === "front") {
              setFrontImages((prev) => [...prev, ...files]);
            } else {
              setBackImages((prev) => [...prev, ...files]);
            }
          }}
        >
          <p style={{ fontSize: "16px", fontWeight: 600 }}>Drag & Drop Images Here</p>
          <p style={{ margin: "10px 0", color: "#999" }}>OR</p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "40px",
              flexWrap: "wrap",
            }}
          >
            {/* Front Upload */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {frontImages.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {frontImages.map((img, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <img
                        src={URL.createObjectURL(img)}
                        alt={`front-${index}`}
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                      />
                      <button
                        onClick={() => handleRemoveImage("front", index)}
                        style={{
                          position: "absolute",
                          top: "2px",
                          right: "2px",
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "50%",
                          width: "16px",
                          height: "16px",
                          fontSize: "11px",
                          cursor: "pointer",
                          lineHeight: "14px",
                          textAlign: "center",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <button
                type="button"
                onClick={() => {
                  setUploadTarget("front");
                  frontInputRef.current.click();
                }}
                style={{
                  padding: "6px 14px",
                  background: "#d8f8dcff",
                  border: "1px solid #076107ff",
                  color: "#012906ff",
                  borderRadius: "6px",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                + Add Front Image
              </button>
            </div>

            {/* Back Upload */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {backImages.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {backImages.map((img, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <img
                        src={URL.createObjectURL(img)}
                        alt={`back-${index}`}
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                      />
                      <button
                        onClick={() => handleRemoveImage("back", index)}
                        style={{
                          position: "absolute",
                          top: "2px",
                          right: "2px",
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "50%",
                          width: "16px",
                          height: "16px",
                          fontSize: "11px",
                          cursor: "pointer",
                          lineHeight: "14px",
                          textAlign: "center",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <button
                type="button"
                onClick={() => {
                  setUploadTarget("back");
                  backInputRef.current.click();
                }}
                style={{
                  padding: "6px 14px",
                  background: "#d8f8dcff",
                  border: "1px solid #076107ff",
                  color: "#012906ff",
                  borderRadius: "6px",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                + Add Back Image
              </button>
            </div>
          </div>

          {/* Hidden Inputs */}
          <input
            type="file"
            accept="image/*"
            ref={frontInputRef}
            style={{ display: "none" }}
            onChange={(e) => {
              if (e.target.files) {
                setFrontImages((prev) => [
                  ...prev,
                  ...Array.from(e.target.files),
                ]);
                console.log(e.target.files);
                formik.setFieldValue("FrontImageFile", e.target.files[0]);
              }
            }}
          />
          <input
            type="file"
            accept="image/*"
            ref={backInputRef}
            style={{ display: "none" }}
            onChange={(e) => {
              if (e.target.files) {
                setBackImages((prev) => [
                  ...prev,
                  ...Array.from(e.target.files),
                ]);
                console.log(e.target.files);
                formik.setFieldValue("BackImageFile", e.target.files[0]);
              }
            }}
          />
        </div>
      </div>)}
   <button
  type="submit"
  className="gradient-button"
  style={{ fontSize: "12px", padding: "6px 12px" }}
>
  {isEditMode ? "UPDATE" : "SAVE"}
</button>

    </form>
  );
}

export default AddBatchForm;
